import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Input, Form, Label} from 'semantic-ui-react';
import {any, number, string, func, element, object, arrayOf, oneOfType} from 'prop-types';
import {addThousandsCommas} from 'utils/DBUtils';

export default class NumericInput extends React.Component {
  static propTypes = {
    label: oneOfType([string, element]),
    value: any.isRequired,
    onValueChanged: func.isRequired,
    validationRules: arrayOf(object),
    errors: arrayOf(object)
  };

  static defaultProps = {
    errors: []
  };

  handleChange = (event, {value}) => {
    value = Number(value);
    this.props.onValueChanged(value, true);
  };

  render() {
    return (
      <Form.Field>
        {this.props.label}
        <Input
          type='number'
          value={this.props.value}
          onChange={this.handleChange} />
        {this.props.errors.map(error => {
          const messageValues = error.type === 'InclusiveRange' ? {
            min: error.params.min,
            max: addThousandsCommas(error.params.max)
          } : {};

          return (
            <Label
              basic
              className='db-error-label'
              key={error.type}>
              <FormattedMessage
                id={`errors.validation.${error.type}`}
                values={messageValues} />&nbsp;
              {error.invalidValues && (
                <FormattedMessage
                  id='errors.validation.invalid_values'
                  values={{invalidValues: error.invalidValues}} />
              )}
            </Label>
          );
        })}
      </Form.Field>
    );
  }
};



// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/NumericInput.jsx